import Card from "./Card.svelte";
import Title from "./Title.svelte";

export default {
  Card,
  Title
};
